module.exports = __webpack_public_path__ + "static/media/39_B.684ec179.png";